import * as React from 'react';
import { getGeneratedNickname } from '../nicknameGeneratorApi';
import { WidgetId } from '@Utils/edge/constants';
import useWidget from '@Utils/core/useWidget';
import useValidateNickname from './useValidateNickname';
import GeneratorContext from '../GeneratorContext';

const useLoadGeneratedNickname = () => {
  const widgetGeneratorDropdownActiveV3 = useWidget(WidgetId.GeneratorDropdownActiveV3);
  const context = React.useContext(GeneratorContext);

  const { validator } = useValidateNickname();

  const loadNickname = React.useCallback(() => {
    getGeneratedNickname(
      widgetGeneratorDropdownActiveV3.options.activeValue,
      context.genderGroup,
    ).then((nickname: string) => {
      context.setGeneratedNickname(nickname);
      validator(nickname);
    });
  }, [context, validator, widgetGeneratorDropdownActiveV3.options.activeValue]);

  return {
    loadNickname,
  };
};

export default useLoadGeneratedNickname;
